import { ApiTagsEnum } from "src/constants/api-tags";
import { ENDPOINTS }   from "src/constants/api/api";
import { api }         from "src/store/services/api";
import type { IUser }  from "src/store/services/users/interfaces/responses.interface";

export const usersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query<{ 
      data : IUser[]; 
      total: number; 
    }, { 
      search?      : string; 
      page?        : number; 
      perPage?     : number; 
      status?      : string; 
      type?        : string; 
      availability?: string; 
      company?     : string; 
      skills?      : string; 
      dateFrom?    : string; 
      dateTo?      : string; 
    } | undefined | void>({
      query: (params = {}) => ({
        url   : ENDPOINTS.USERS_LIST.GET_ADMIN_USERS,
        method: "GET",
        params,
      }),
      providesTags: [ApiTagsEnum.USERS],
    }),
    getUserById: build.query<IUser, number>({
      query: (id: number) => ({
        url   : `${ENDPOINTS.USERS_LIST.GET_ADMIN_USERS}/${id}`,
        method: "GET",
      }),
      providesTags: [ApiTagsEnum.USERS],
    }),
    getAvailableUsersForProject: build.query<IUser[], number>({
      query: (projectId: number) => ({
        url   : `${ENDPOINTS.USERS_LIST.GET_AVAILABLE_USERS_FOR_PROJECT}/${projectId}`,
        method: "GET",
      }),
      providesTags: [ApiTagsEnum.USERS],
    }),
  }),
});

export const { useGetAvailableUsersForProjectQuery,
  useGetUserByIdQuery,
  useGetUsersQuery, } = usersApi;
